import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-add-on-feature',
  templateUrl: './add-on-feature.component.html',
  styleUrls: ['./add-on-feature.component.scss'],
})
export class AddOnFeatureComponent {
  @Input() prevTab: Function = () => {};
  @Input() isReadOnly: boolean = false;
}
